<template>
  <main id="app"
        class="page-wrapper"
        @click="setInteraction($event)">

    <!-- רקע המערכת (הגדרות → כללי): a very faint drawing on the gray behind the cards, under every page - off
         unless the business picked one (homepage_setting.settings.pageBackground, Common/page-backdrops.js) -->
    <PageBackdrop v-if="pageBackdrop"
                  :backdrop="pageBackdrop"></PageBackdrop>


    <!-- <div id="fixedPlusButton" style="font-size:22px;cursor:pointer;border:1px solid #eee;box-shadow:0 1px 11px 0 rgba(0,0,0,.1);display:flex;justify-content: center;align-items: center;  z-index:99;position:fixed;bottom: 20px;left:20px;height:65px;width:65px;border-radius:100%;color:white;background-color:#ab8ce4;">
      <i class="fa fa-plus"></i>
    </div> -->






    <div id="loadingOverlay"
         v-show="isLoading">
      <i class="fa-solid fa-gear fa-spin"></i>
    </div>






    <HeaderNav v-if="$router.currentRoute.name != 'login' && !isHostingStationUser"
               @openQuickCalendar="showQuickCalendar"
               @toggleMenu="hideSidebar = !hideSidebar"></HeaderNav>

    <div class=''
         :class='{ "sidebar-close": hideSidebar, "page-body-wrapper": $store.state.isLogged, "hostingStationView": isHostingStationUser, "hasPageBackdrop": !!pageBackdrop }'>

      <SideMenu ref="sideMenu"
                @hideSidebarIfMobile="hideSidebar = $globals.screenIsMobile"
                v-if="$store.state.isLogged && !isHostingStationUser"></SideMenu>



      <!-- change the min-height of page-body to be by class -->

      <div class="page-body">

        <!-- Feature 2: Tax Authority (Heshboniot Israel) re-authorization banner - the 90 days, or a
             consent of the scope from before 1/11/2026. Inside the page's body: above it, it sat at
             the top of the window under the fixed header, and nobody ever saw it (5/11/2026). -->
        <!-- the padding keeps the gap under the header (a margin collapsed into the body's); on a
             phone the button wraps under the text instead of squeezing it into a column -->
        <div v-if="heshboniotIsraelBanner"
             class="taxAuthorityBanner"
             style="padding-top:12px">
          <div class="alert mb-0 d-flex flex-wrap align-items-center"
               :class="heshboniotIsraelBanner.level === 'danger' ? 'alert-danger' : 'alert-warning'"
               style="gap:10px 12px;padding:10px 18px">
            <i class="fa-solid fa-triangle-exclamation"></i>
            <span style="flex:1 1 220px">{{ heshboniotIsraelBanner.text }}</span>
            <a :href="taxAuthorityReauthUrl"
               class="btn btn-sm btn-primary"
               style="white-space:nowrap">
              <i class="fa-solid fa-building-columns"></i> התחבר מחדש לרשות המסים
            </a>
          </div>
        </div>

        <div style="padding-bottom:50px;min-height:100vh"
             class="togglePaddingBottom50">



          <div :class="{ notFullWidth }">



            <transition name="slide-fade"
                        mode="out-in"
                        appear>
              <router-view :key="routerViewKey" />
            </transition>

          </div>



        </div>






        <!-- fugly but works -->
        <v-style v-if="$router.currentRoute.name == 'login'">

          @media (min-width:989px){
          footer.dark-footer{
          position: absolute !important;
          }
          .togglePaddingBottom50{
          padding-bottom:0 !important;
          }
          }

        </v-style>

        <v-style v-if="$router.currentRoute.name == 'landing' || $router.currentRoute.name == 'Blog' || $router.currentRoute.name == 'BlogPost' || $router.currentRoute.name == 'signup'">
          html, body {
            overflow: hidden !important;
          }
          .page-body-wrapper {
            padding: 0 !important;
            margin: 0 !important;
          }
          .page-body {
            padding: 0 !important;
            margin: 0 !important;
            min-height: auto !important;
          }
          .togglePaddingBottom50 {
            padding-bottom: 0 !important;
            min-height: auto !important;
          }
          /* Position the landing iframe below the Vue header */
          .landing-container {
            top: 64px !important;
            height: calc(100% - 64px) !important;
          }
          @media (min-width: 768px) {
            .landing-container {
              top: 80px !important;
              height: calc(100% - 80px) !important;
            }
          }
          /* Hide the sidebar that might show */
          .page-sidebar {
            display: none !important;
          }
        </v-style>


        <footer class="dark-footer" v-if="$router.currentRoute.name != 'landing' && $router.currentRoute.name != 'Blog' && $router.currentRoute.name != 'BlogPost' && $router.currentRoute.name != 'signup'">
          <div class="container-fluid">
            <div class="row">
              <div class="col-6 footer-copyright">
                <p class="mb-0">



                  2024

                  <br class="hideForDesktop">
                  &#169;

                  PlanUp


                  <br class="hideForDesktop">

                  מבית


                  <a href="index.html"
                     style="color:#0E9A86">mit4mit</a>


                </p>
              </div>
              <div class="col-6">
                <ul class="footer-links">
                  <li><router-link to="/terms">תנאי שימוש</router-link></li>
                  <br class="hideForDesktop">
                  <li><router-link to="/privacy">פרטיות</router-link></li>
                  <br class="hideForDesktop">
                  <li><router-link to="/accessibility">נגישות</router-link></li>
                </ul>
              </div>
            </div>
          </div>
        </footer>

      </div>
    </div>

    <ContactModal v-if="$store.state.isLogged" />

    <TaskModal v-if="$store.state.isLogged"
               ref="taskModal" />

    <!-- אישי: a personal block of time on the calendar (מילואים, רופא...) - opened from the calendar's
         day popup, a pill of its own, and the side menu's + ($root 'openPersonalItemModal') -->
    <PersonalItemModal v-if="$store.state.isLogged"
                       ref="personalItemModal" />




    <Modal xlarge="true"
           title="יומן פעילויות"
           subtitle="ניהול ותצוגת כל הפעילויות החודשיות"
           icon="fa-regular fa-calendar"
           class="quickCalendar"
           period="day"
           :hideFooter="true"
           ref="quickCalendar">

      <template v-slot:body>






        <div class="planupCalendarWrapper horizontalCustomerScrollbar">
          <PlanupCalendar :hideHeaderButtons="false"
                          ref="quickCalendarActualCalendar"
                          v-if="$store.state.isLogged"
                          height="770px"></PlanupCalendar>
        </div>



      </template>



    </Modal>




    <CommentModal ref="commentModal" />





    <Modal ref="globalPdfIframeModal"
           class="globalPdfIframeModal"
           :title="globalPdfIframeModalTitle"
           :xlarge="true"
           :hideFooter="true">

      <template v-slot:body>

        <!-- הורדת PDF: the file itself - for a phone / iPad that can't display the document inline
             (and anyone who wants the file). Absent for non-PDF content (the signing page). -->
        <div v-if="globalPdfIframeModalDownload"
             class="globalPdfIframeModalToolbar">
          <button type="button"
                  class="btn btn-primary btn-sm globalPdfDownloadButton"
                  :disabled="globalPdfIframeModalDownloading"
                  @click="downloadGlobalPdf">
            הורדת PDF
            &nbsp;
            <i class="fa-solid fa-download"></i>
          </button>
          <span v-if="$globals.isMobile || $globals.cantEmbedPdf"
                class="globalPdfIframeModalNotice">המסמך לא מוצג? ניתן להוריד אותו</span>
        </div>

        <iframe :src="globalPdfIframeModalSrc"
                style="width:100%;border:none;height:70vh"
                v-if="globalPdfIframeModalSrc && !globalPdfIframeModalIsImage">

        </iframe>

        <!-- iOS/iPadOS can't embed PDFs in iframes — the modal gets a JPEG render instead -->
        <div v-if="globalPdfIframeModalSrc && globalPdfIframeModalIsImage"
             style="width:100%;height:70vh;overflow:auto">
          <img :src="globalPdfIframeModalSrc"
               style="width:100%;height:auto">
        </div>
      </template>
    </Modal>


    <Modal ref="targetForNewEntityModal"
           :title="$t('targetForNewEntityModalTitleFor_' + chosenEntityToCreateInPopup)"
           :hideFooter="true">

      <template v-slot:body>

        <div style="display:flex;justify-content: center;align-items:center;">

          <div v-if="$route.name == 'CustomerPage'">

            <div v-show="chosenEntityToCreateInPopup == 'meeting'"
                 data-bs-dismiss="modal"
                 class="card popupOptionBlock"
                 :class="chosenEntityToCreateInPopup"
                 @click="$root.$emit('addMeetingToThisCustomer')">
              <div>
                <i class="fa-solid fa-user-pen"
                   style="transform:scale(0.75)"></i>
                <br>
                לקוח הזה
              </div>
            </div>


            <div v-show="chosenEntityToCreateInPopup == 'event'"
                 data-bs-dismiss="modal"
                 class="card popupOptionBlock"
                 :class="chosenEntityToCreateInPopup"
                 @click="$root.$emit('addEventToThisCustomer')">
              <div>
                <i class="fa-solid fa-user-pen"
                   style="transform:scale(0.75)"></i>
                <br>
                לקוח הזה
              </div>
            </div>

            <div v-show="chosenEntityToCreateInPopup == 'taxDocument'"
                 data-bs-dismiss="modal"
                 class="card popupOptionBlock"
                 :class="chosenEntityToCreateInPopup"
                 @click="$root.$emit('addTaxDocumentToThisCustomer', chosenEntityToCreateInPopup_extraParams)">
              <div>
                <i class="fa-solid fa-user-pen"
                   style="transform:scale(0.75)"></i>
                <br>
                לקוח הזה
              </div>
            </div>


          </div>












          <div v-show="chosenEntityToCreateInPopup == 'event'"
               data-bs-dismiss="modal"
               class="card popupOptionBlock"
               :class="chosenEntityToCreateInPopup"
               @click="$handlers.customerHandler.goToAddCustomerAddEvent()">
            <div>
              <i class="fa-solid fa-user-plus"
                 style="transform:scale(0.75)"></i>
              <br>
              {{ $t('newCustomer') }}
            </div>
          </div>

          <div v-show="chosenEntityToCreateInPopup == 'event'"
               data-bs-dismiss="modal"
               class="card popupOptionBlock"
               :class="chosenEntityToCreateInPopup"
               @click="$root.$emit('findCustomer', $handlers.eventHandler.gotoAddNewEventToCustomerFromSearchResult)">
            <div>
              <i class="fa-solid fa-user-group"
                 style="transform:scale(0.75)"></i>
              <br>
              {{ $t('existingCustomer') }}
            </div>
          </div>

          <div v-show="chosenEntityToCreateInPopup == 'event'"
               class="card popupOptionBlock"
               :class="chosenEntityToCreateInPopup"
               @click="sendEventLinkViaWhatsapp()">
            <div>
              <i class="fa-solid fa-link"
                 style="transform:scale(0.75)"></i>
              <br>
              קישור לטופס
            </div>
          </div>





          <!-- --- -->






          <div v-show="chosenEntityToCreateInPopup == 'taxDocument'"
               data-bs-dismiss="modal"
               class="card popupOptionBlock"
               :class="chosenEntityToCreateInPopup"
               @click="$router.push(`/createTaxDocument?type=${chosenEntityToCreateInPopup_extraParams.taxDocumentType.value}`)">
            <div>
              <i class="fa-solid fa-user-plus"
                 style="transform:scale(0.75)"></i>
              <br>
              {{ $t('newCustomer') }}
            </div>
          </div>

          <div v-show="chosenEntityToCreateInPopup == 'taxDocument'"
               data-bs-dismiss="modal"
               class="card popupOptionBlock"
               :class="chosenEntityToCreateInPopup"
               @click="$root.$emit('findCustomer', $handlers.taxDocumentHandler.createGoToFunctionForFindCustomer(chosenEntityToCreateInPopup_extraParams.taxDocumentType))">
            <div>
              <i class="fa-solid fa-user-group"
                 style="transform:scale(0.75)"></i>
              <br>
              {{ $t('existingCustomer') }}
            </div>
          </div>



          <div v-show="chosenEntityToCreateInPopup == 'meeting'"
               data-bs-dismiss="modal"
               class="card popupOptionBlock"
               :class="chosenEntityToCreateInPopup"
               @click="openMeetingWithoutCustomerModal()">
            <div>
              <i class="fa-solid fa-user-slash"
                 style="transform:scale(0.75)"></i>
              <br>
              {{ $t('withoutCustomer') }}
            </div>
          </div>



          <div v-show="chosenEntityToCreateInPopup == 'meeting'"
               data-bs-dismiss="modal"
               class="card popupOptionBlock"
               :class="chosenEntityToCreateInPopup"
               @click="$handlers.customerHandler.goToAddCustomerOnlyMeeting();">
            <div>
              <i class="fa-solid fa-user-plus"
                 style="transform:scale(0.75)"></i>
              <br>
              {{ $t('newCustomer') }}
            </div>
          </div>

          <div v-show="chosenEntityToCreateInPopup == 'meeting'"
               data-bs-dismiss="modal"
               class="card popupOptionBlock"
               :class="chosenEntityToCreateInPopup"
               @click="$root.$emit('findCustomer', $handlers.meetingHandler.gotoAddNewMeetingFromSearch)">
            <div>
              <i class="fa-solid fa-user-group"
                 style="transform:scale(0.75)"></i>
              <br>
              {{ $t('existingCustomer') }}
            </div>
          </div>

          <!-- Send the public booking link (invitation) — only for accounts where the system
               admin enabled the online-booking service -->
          <div v-show="chosenEntityToCreateInPopup == 'meeting' && bookingServiceEnabled"
               class="card popupOptionBlock"
               :class="chosenEntityToCreateInPopup"
               @click="sendBookingLinkViaWhatsapp()">
            <div>
              <i class="fa-solid fa-link"
                 style="transform:scale(0.75)"></i>
              <br>
              קישור לתיאום פגישה
            </div>
          </div>






          <div v-show="chosenEntityToCreateInPopup == 'task'"
               data-bs-dismiss="modal"
               class="card popupOptionBlock"
               :class="chosenEntityToCreateInPopup"
               @click="$root.$emit('openTaskModal')">
            <div>
              <i class="fa-solid fa-user-slash"
                 style="transform:scale(0.75)"></i>
              <br>
              {{ $t('withoutCustomer') }}
            </div>
          </div>



          <div v-show="chosenEntityToCreateInPopup == 'task'"
               data-bs-dismiss="modal"
               class="card popupOptionBlock"
               :class="chosenEntityToCreateInPopup"
               @click="$handlers.customerHandler.goToAddCustomerOnlyTask();">
            <div>
              <i class="fa-solid fa-user-plus"
                 style="transform:scale(0.75)"></i>
              <br>
              {{ $t('newCustomer') }}
            </div>
          </div>

          <div v-show="chosenEntityToCreateInPopup == 'task'"
               data-bs-dismiss="modal"
               class="card popupOptionBlock"
               :class="chosenEntityToCreateInPopup"
               @click="$root.$emit('findCustomer', $handlers.tasksHandler.gotoAddNewTaskFromSearch)">
            <div>
              <i class="fa-solid fa-user-group"
                 style="transform:scale(0.75)"></i>
              <br>
              {{ $t('existingCustomer') }}
            </div>
          </div>






        </div>
      </template>
    </Modal>

    <SendLinkViaWhatsappModal ref="sendLinkViaWhatsappModal" />

    <notifications position="top center"
                   @click.native="clickOnNotification($event)"
                   class="planupnotification">

    </notifications>

    <!-- THIS MODAL SHOULD BE LAST TO BE ABOVE ALL MODALS -->
    <FindCustomerModal v-if="$store.state.isLogged"
                       ref="findCustomerModal"></FindCustomerModal>

    <!-- opened from a duplicate-phone bell notification ('duplicate:<new>:<existing>' link) -->
    <DuplicatePhoneModal v-if="$store.state.isLogged"
                         ref="duplicatePhoneModal"></DuplicatePhoneModal>

    <!-- מחיקת לקוח: mark the פניה לא רלוונטית or really delete - the customer card and the trash on
         the /customers table (customerHandler.askDeleteCustomer) -->
    <DeleteCustomerModal v-if="$store.state.isLogged"
                         ref="deleteCustomerModal"></DeleteCustomerModal>

    <AiInsightsPanel v-if="$store.state.isLogged && !$store.state.disabledFeatures.includes('ai')" />

    <!-- the support thread (header headset button). Business users only - the root admin answers
         these at /root-admin/support -->
    <SupportModal v-if="$store.state.isLogged && $store.state.user && $store.state.user.type != 1"
                  ref="supportModal"></SupportModal>

    <!-- the root admin froze this account: a non-closable cover over the logged-in shell
         (appData.frozen, or a request refused with frozen: true) -->
    <AccountFrozenModal v-if="$store.state.isLogged && $store.state.accountFrozen" />

    <!-- announcements the root admin sent (הכרזות, /root-admin/announcements) - popups for business
         users; the component itself skips the kiosk user and waits for a quiet screen -->
    <AnnouncementPopup v-if="$store.state.isLogged && $store.state.user && $store.state.user.type != 1 && !$store.state.accountFrozen" />

    <!-- ערכת פתיחה: "want us to set up an agreement / whatsapp templates / automations?" - due on
         a new account's first load (appData.starterKit.prompt), or again when the root admin asks -->
    <StarterKitModal v-if="$store.state.isLogged && $store.state.starterKit && $store.state.starterKit.prompt && !$store.state.accountFrozen" />

    <!-- "הוסיפו את PlanUp למסך הבית" - the small popup after login on phones / tablets, and the
         one the settings section (אפליקציה במסך הבית) opens; it also registers public/sw.js -->
    <HomeScreenPrompt v-if="$store.state.isLogged && $store.state.user && $store.state.user.type != 1" />

    <!-- פרטי העסק לחשבונאות (ח.פ / ע.מ, ספרור מסמכים): asked once a session on the first finance screen,
         while they are missing - it replaced the bounce to /settings and Settings' welcome popup -->
    <TaxDetailsPrompt v-if="$store.state.isLogged && $store.state.user && $store.state.user.type != 1 && !$store.state.accountFrozen" />


    <QuickMeetingModal v-if="meetingWithoutCustomer"
                       ref="meetingWithoutCustomerModal"
                       @savedMeeting="meetingWithoutCustomer = null"
                       :meetingToEdit="meetingWithoutCustomer"></QuickMeetingModal>



    <!-- the app-wide chat: the Modal's own header is off, the chat's header carries the close
         button (inModal); its look lives in PlanupMultiMessagesChat.vue -->
    <Modal :hideFooter="true"
           :hideHeader="true"
           ref="globalChatBox"
           class="globalChatBoxModal">

      <template v-slot:body>
        <PlanupMultiMessagesChat ref="globalChatBoxInner"
                                 :msgGroup="chatMsgGroup"
                                 :inModal="true"
                                 @openCustomer="$refs.globalChatBox.hide()"></PlanupMultiMessagesChat>
      </template>


    </Modal>



    <SummonModal ref="summonModal"></SummonModal>

    <CancelEvent ref="cancelEvent"></CancelEvent>
    <ChangeEventStatus ref="changeEventStatus"></ChangeEventStatus>

    <!-- "האתר משתמש בקוקיז" - on the public site only (landing, blog, signup, login, the legal
         pages) and never for a logged-in user, until the visitor closes it, once per browser -->
    <CookieNotice />


  </main>
</template>

<script>

import QuickMeetingModal from './components/Meeting/QuickMeetingModal.vue';
import CommentModal from './components/CommentModal/CommentModal.vue';
import FindCustomerModal from './components/Customers/FindCustomerModal.vue';
import DuplicatePhoneModal from './components/Customers/DuplicatePhoneModal.vue';
import ContactModal from './components/Modals/ContactModal';
import SendLinkViaWhatsappModal from './components/Modals/SendLinkViaWhatsappModal.vue';
import CookieNotice from './components/Common/CookieNotice.vue';
import PageBackdrop from './components/Common/PageBackdrop.vue';
import { backdropByKey } from './components/Common/page-backdrops';
import SideMenu from './components/Common/SideMenu.vue'
import HeaderNav from './components/Common/HeaderNav.vue'
import Login from './components/Login.vue';
import axiosV2 from './core/http/axios_api_v2';
import { getTaxAuthorityAuthorizeUrl } from './core/heshboniotIsrael';
import TaskModal from './components/Tasks/TaskModal.vue';
import PersonalItemModal from './components/Calendar/PersonalItemModal.vue';
import PlanupCalendar from './components/Calendar/PlanupCalendar.vue';
import PlanupMultiMessagesChat from './components/PlanupMultiMessages/PlanupMultiMessagesChat.vue';
import SummonModal from './components/SummonModal/SummonModal.vue';
import AiInsightsPanel from './components/AiInsights/AiInsightsPanel.vue';
import SupportModal from './components/Support/SupportModal.vue';
import AccountFrozenModal from './components/Common/AccountFrozenModal.vue';
import AnnouncementPopup from './components/Announcements/AnnouncementPopup.vue';
import StarterKitModal from './components/StarterKit/StarterKitModal.vue';
import HomeScreenPrompt from './components/HomeScreen/HomeScreenPrompt.vue';
import TaxDetailsPrompt from './components/Onboarding/TaxDetailsPrompt.vue';
import CancelEvent from './components/Events/CancelEvent.vue';
import ChangeEventStatus from './components/Events/ChangeEventStatus.vue';
import DeleteCustomerModal from './components/Customers/DeleteCustomerModal.vue';
import hasPermission from '@/core/acl/acl';
import { isHostingStationUser } from '@/core/acl/venue';
import Config from './Config.js';
import BookingInvite from './modules/BookingInvite';
import { applyCalendarColors } from './services/calendar/calendar-colors';


export default {
  name: 'App',
  data() {
    return {
      notFullWidth: true,
      meetingWithoutCustomer: null,
      chatMsgGroup: '',
      hideSidebar: false,
      chosenEntityToCreateInPopup: null,
      chosenEntityToCreateInPopup_extraParams: null,
      globalPdfIframeModalSrc: null,
      globalPdfIframeModalTitle: null,
      globalPdfIframeModalIsImage: false,
      // { pdfId, fileName, base64Content? } - the modal's הורדת PDF button; null = no button
      globalPdfIframeModalDownload: null,
      globalPdfIframeModalDownloading: false,
      isLoading: false,
    }
  },

  beforeMount() {
    window.seatupApp = this;
    window.planup = this; //yonso add
    window.axios = axiosV2;




    //to make clones of an object, so that we can edit something without disturbing the original
    window.deepCopy = function (o) { if (!o) return null; return JSON.parse(JSON.stringify(o)) };
    window.emptyObject = o => !Object.keys(o).length;
    window.shallowCopy = function (o) { let o2 = {}; Object.assign(o2, o); return o2; }
    window.setNoon = function (d) { d && d.setHours && d.setHours(12) }




    window.removeFromArray = (removeMe, arr, replacement) => {

      let index = arr.findIndex(e => e == removeMe);
      arr.splice(index, 1, replacement);


    }




    window.componentPath = (c) => {

      if (c.$options.name == 'App')
        return 'App';

      return componentPath(c.$parent) + '.' + c.$options.name;
    }


    //usually to bring our changes to the original object, we update each key 
    // window.keyCopy = (source,destination)=>{

    //   if (!destination)
    //     return;

    //   let keys = Object.keys(source);
    //         for (let i=0; i<keys.length; i++){
    //           destination[keys[i]] = source[keys[i]];
    //         }
    // }



    //not the prettiest injection, but very comfortable to use
    //also - i now understand that splice and push are vue functions, so i really mostly won't need this
    //i would never really REPLACE an item in an array eg. list[4] = somethingElse, i would edit list[4].someField = somethingElse
    // this.$store.updateList = (listName) => planup.$store.state[listName] = deepCopy(planup.$store.state[listName])

    this.$store.commit('setAccessToken', null);


  },



  watch: {


    // catalog/inventory businesses call a closed deal הזמנה חתומה, not אירוע סגור —
    // every consumer (filters, reports, pills) reads this store entry, so flipping the
    // label here renames it everywhere at once
    '$store.state.user': {

      immediate: true,

      handler(user) {
        let hazmanaSigned = this.$store.state.planupSystemStatuses.find(status => status.value == 'hazmanaSigned');
        if (hazmanaSigned)
          hazmanaSigned.label = hasPermission(user, 'inventory') ? 'הזמנה חתומה' : 'אירוע סגור';
      }

    },


    '$store.state.calendarCheckboxes': {

      handler(newVal) {
        localStorage.setItem('calendarCheckboxes', JSON.stringify(newVal));
      },

      deep: true

    },


    // צבעי לוח שנה: the calendar's color stylesheet follows the settings, also while they are edited
    calendarColorsKey: {

      immediate: true,

      handler() {
        applyCalendarColors(this.$store.state.businessSettings);
      }

    },



    // i think this is the init of planupCustomerStatuses from server to quickSuperEdit
    '$store.state.planupCustomerStatuses': function (newValue) {


      if (!newValue.length)
        return;

      newValue.forEach(status => {
        //already init
        if (status.type && typeof status.type == 'object')
          return;
        //a status with no type set has no archive semantics - don't default it to לא רלוונטי
        status.type = planup.$handlers.customerHandler.planupCustomerStatusTypeOptions.find(x => x.value == status.type) || null;
      });
    },


  },





  methods: {

    openMeetingWithoutCustomerModal(date, meeting, time) {

      this.meetingWithoutCustomer = meeting ? meeting : this.$handlers.meetingHandler.generateLocalEmptyMeeting({}, date, time);
      this.$nextTick(() => this.$refs.meetingWithoutCustomerModal.show())

    },


    showQuickCalendar(displayType, date) {

      switch (displayType) {

        case 'day':
          if (date) {
            this.$refs.quickCalendarActualCalendar.singleDayViewDate = date;
            this.$refs.quickCalendarActualCalendar.updateItems(date);
          }
          this.$refs.quickCalendarActualCalendar.setDayView()
          break;

        case 'week':
          this.$refs.quickCalendarActualCalendar.setWeekView()
          break;

        default:
          this.$refs.quickCalendarActualCalendar.setMonthView()
      }

      this.$refs.quickCalendar.show();
      setTimeout(this.$refs.quickCalendarActualCalendar.centerMultipleCalendars, 200);


    },


    clickOnNotification(event) {

      if (event.target.classList.contains('whatsapp')) {



        let contactId = Array.from(event.target.classList).find(c => c.slice(0, 7) == 'contact').slice(7);
        // let customerId = Array.from(event.target.classList).find(c => c.slice(0, 8) == 'customer').slice(8);


        this.$root.$emit('globalChatBox', `whatsapp_contact_${contactId}`)


      }


      //a support reply arrived while the support modal was closed - the toast opens it
      if (event.target.classList.contains('supportmessage')) {
        this.$root.$emit('openSupportModal');
        return;
      }

      //incoming email toast - the msgGroup is carried whole (it is either mail_contact_<id> or
      //mail_<address>, so it cannot be rebuilt from a contact id like the whatsapp one)
      if (event.target.classList.contains('emailmessage')) {

        let groupClass = Array.from(event.target.classList).find(c => c.slice(0, 6) == 'group_');

        if (groupClass)
          this.$root.$emit('globalChatBox', groupClass.slice(6));

      }

    },

    openGlobalChatBox(msgGroup) {

      this.chatMsgGroup = msgGroup;
      this.$refs.globalChatBox.show();
      setTimeout(() => {
        this.$refs.globalChatBoxInner.scrollToBottom();
        this.$refs.globalChatBoxInner.$refs.messageToSendInput?.focus();
      }
        , 200)

    },



    closeMenuIfMobile() {

      if (this.$globals.screenIsMobile)
        this.hideSidebar = true;
    },


    showGlobalPdfIframeModal(src, title, isImage, download) {
      this.globalPdfIframeModalSrc = src;
      this.globalPdfIframeModalTitle = title;
      this.globalPdfIframeModalIsImage = !!isImage;
      this.globalPdfIframeModalDownload = download || null;
      this.$refs.globalPdfIframeModal.show();
    },

    async downloadGlobalPdf() {

      this.globalPdfIframeModalDownloading = true;

      try {
        await this.$handlers.documentsHandler.downloadPdf(this.globalPdfIframeModalDownload);
      } finally {
        this.globalPdfIframeModalDownloading = false;
      }
    },


    openTargetForNewEntityModal(entity, extraParams) {
      // אישי has no customer to pick: straight to its form
      if (entity == 'personal') {
        this.$root.$emit('openPersonalItemModal');
        return;
      }
      this.chosenEntityToCreateInPopup = entity;
      this.chosenEntityToCreateInPopup_extraParams = extraParams;
      this.$refs.targetForNewEntityModal.show();
    },

    sendEventLinkViaWhatsapp() {
      const link = Config.contactLink(this.$store.state.tenantId);

      // Hide the entity modal and show the WhatsApp modal
      this.$refs.targetForNewEntityModal.hide();
      this.$refs.sendLinkViaWhatsappModal.show(link);
    },

    // Invitation to book a meeting through the public booking link (service-gated feature),
    // in the wording saved in the booking settings.
    sendBookingLinkViaWhatsapp() {
      this.$refs.targetForNewEntityModal.hide();
      BookingInvite.open(this.$root, Config.bookingLink(this.$store.state.tenantId));
    },

    findCustomer(callback, ...args) {

      // we call the callback with a new field on the customer - chosenEvent
      this.$refs.findCustomerModal.show((customer) => { callback(customer, ...args) });
    },


    goBack() {
      if (window.routerLastFrom == 'login') {
        this.$router.push('/');
      } else {
        this.$router.go(-1);
      }
    },

    // this closes open menus if clicked outside of them.
    // currently it is by id but can be changed to class if we have multiple menus
    setInteraction(clickEvent) {


      let isMenuOpenerButton;


      let element = clickEvent.target;




      while (element) {

        if (element.getAttribute('class') && element.getAttribute('class').includes('popupMenuToHideOrNot_openerButton'))

          isMenuOpenerButton = true;

        element = element.parentElement;

      }

      if (!isMenuOpenerButton) {

        document.querySelectorAll('.popupMenuToHideOrNot').forEach(e => e.classList.remove('popupMenuToHideOrNot_showMenu'))

      }


    },

  },

  computed: {

    // everything the calendar's color stylesheet is built from (calendar-colors.js); the stringify
    // reads every nested color, so a single status' color change is seen too
    calendarColorsKey() {
      const settings = this.$store.state.businessSettings || {};
      return JSON.stringify([settings.calendarEventColor, settings.calendarTaskColor, settings.calendarMeetingColor, settings.calendarColors || null]);
    },

    // Feature 2: 90-day Tax Authority re-authorization banner (yellow <=14 days, red once expired).
    // Red too for a consent given before the Tax Authority's new scope (1/11/2026): its tokens are
    // refused whatever the days left, and only a new consent cures it (auth-status scopeOutdated).
    heshboniotIsraelBanner() {
      const status = this.$store.state.heshboniotIsraelAuthStatus;
      if (!status || !status.connected) return null;
      if (status.scopeOutdated)
        return { level: 'danger', text: 'רשות המסים שינתה ב-1/11/2026 את אופן החיבור, וההרשאה שניתנה לפני השינוי כבר לא מתקבלת. יש להתחבר מחדש לרשות המסים פעם אחת כדי שחשבוניות חדשות יקבלו מספר הקצאה.' };
      const days = status.daysRemaining;
      if (days == null) return null;
      if (days <= 0)
        return { level: 'danger', text: 'ההרשאה מול רשות המסים פגה. חשבוניות חדשות לא יקבלו מספר הקצאה עד להתחברות מחדש.' };
      if (days <= 14)
        return { level: 'warning', text: 'ההרשאה מול רשות המסים תפוג בעוד ' + days + ' ימים. מומלץ להתחבר מחדש כדי להמשיך לקבל מספרי הקצאה.' };
      return null;
    },

    taxAuthorityReauthUrl() {
      return getTaxAuthorityAuthorizeUrl();
    },

    // Online booking is a per-account service the SYSTEM admin enables (biz-services id 10).
    bookingServiceEnabled() {
      const user = this.$store.getters.getUser || {};
      return (user.bizServices || []).map(String).includes('10');
    },

    // עמדת אירוח: the reception-desk login gets the station full-screen — no header, no menu
    isHostingStationUser() {
      return isHostingStationUser(this.$store.getters.getUser);
    },

    // רקע המערכת: the design the business picked, on the app's own pages only - not before login, not on the
    // public pages a logged-in user may open (landing, blog, signup) and not at the reception station
    pageBackdrop() {
      const key = (this.$store.state.homepageSettings || {}).pageBackground;
      if (!this.$store.state.isLogged || this.isHostingStationUser || !backdropByKey(key))
        return '';
      if (['login', 'landing', 'Blog', 'BlogPost', 'signup'].indexOf(this.$route.name) != -1)
        return '';
      return key;
    },

    // vue-router reuses the mounted component when only the params change, and CustomerPage
    // reads its customer once on mount - so /customer/1 → /customer/2 (search, a notification,
    // the chat header) changed the URL but kept showing customer 1. Keying on the id remounts it;
    // every other route (and a query / hash change on the same card) stays unkeyed as before.
    routerViewKey() {
      return this.$route.name == 'CustomerPage' ? `customer_${this.$route.params.id}` : undefined;
    },
  },

  mounted() {



    this.hideSidebar = this.$globals.screenIsMobile;



    this.$root.$on('enableNotFullWidth', () => { this.notFullWidth = true; });
    this.$root.$on('disableNotFullWidth', () => { this.notFullWidth = false; });

    this.$root.$on('hideSidebarIfMobile', () => { this.closeMenuIfMobile(); return true });

    this.$root.$on('findCustomer', this.findCustomer);
    // Lets any page open the WhatsApp send-link modal with a prefilled message (and optional phone)
    this.$root.$on('openSendLinkViaWhatsappModal', (message, phone, options) => this.$refs.sendLinkViaWhatsappModal.show(message, phone, options));
    this.$root.$on('openTaskModal', (task) => this.$refs.taskModal.show(task))  //arrow function because taskmodal is not loaded if not logged in
    // אישי: (item | {id} | null, date, 'HH:MM') - an existing item, or a new one on that day / hour
    this.$root.$on('openPersonalItemModal', (item, date, time) => this.$refs.personalItemModal && this.$refs.personalItemModal.show(item, date, time))
    this.$root.$on('showGlobalPdfIframeModal', this.showGlobalPdfIframeModal);
    this.$root.$on('globalChatBox', this.openGlobalChatBox);
    this.$root.$on('resolveDuplicatePhone', (newCustomerId, existingCustomerId) =>
      this.$refs.duplicatePhoneModal.showForResolve(newCustomerId, existingCustomerId));
    //ask-before-save flavour for create forms that have no room for their own instance
    this.$root.$on('askDuplicatePhone', (phone, duplicates, callback) =>
      this.$refs.duplicatePhoneModal.ask(phone, duplicates).then(callback));
    this.$root.$on('askDeleteCustomer', (options, callback) =>
      this.$refs.deleteCustomerModal.ask(options).then(callback));
    this.$root.$on('showQuickCalendar', this.showQuickCalendar);
    this.$root.$on('hideQuickCalendar', this.$refs.quickCalendar.hide);
    this.$root.$on('openTargetForNewEntityModal', this.openTargetForNewEntityModal);
    this.$root.$on('showSpinner', () => this.isLoading = true);
    this.$root.$on('hideSpinner', () => this.isLoading = false);
    this.$root.$on('showCommentModal', this.$refs.commentModal.show);
    this.$root.$on('showSummonModal', this.$refs.summonModal.show);

    this.$root.$on('cancelEvent', (event) => this.$refs.cancelEvent.show(event));
    this.$root.$on('changeEventStatus', (event, customerId) => this.$refs.changeEventStatus.show(event, customerId));

    //the api refused a request because the root admin froze this account (axiosV2 interceptor):
    //cover the shell with the frozen modal right away, no reload needed
    document.addEventListener('planupAccountFrozen', () => { this.$store.state.accountFrozen = true; });


    //when close global chat box modal remove the active chat
    let that = this;
    $('.globalChatBoxModal').on('hidden.bs.modal', function () {
      that.chatMsgGroup = '';

    })




    // apiRequest error alerts
    document.addEventListener('s_apiError', (customEvent) => {
      const errorData = customEvent.detail

      //hide spinner in case it was shown
      this.isLoading = false;

      //a frozen account's refused request: the blocking modal says it all, no toast on top
      if (errorData && errorData.data && errorData.data.frozen)
        return;

      // Errors without a JSON body (e.g. a raw nginx 504 page) have no .message —
      // swal crashes on an undefined title, so fall through to the generic toast instead.
      const errMessage = errorData && errorData.message;

      if (errMessage && errMessage != 'Internal server error') {
        // alert(customEvent.detail.message);
        // return;

        this.$swal({
          title: errMessage,
          type: 'warning',
          confirmButtonText: 'המשך',
        });

        return;
      }



      this.$notify({
        type: 'error',
        title: 'שגיאה בהעברת הנתונים',
        // text: errorData?.message || this.$t('error'),
        text: 'התרחשה שגיאה בעת הפנייה לשרת.',
        duration: 2500
      })
    }, false);

    // apiRequest success alerts
    document.addEventListener('s_apiSuccess', (customEvent) => {
      const code = customEvent.detail


      //hide spinner in case it was shown
      this.isLoading = false;
      if (code == 'resource_created') {
        this.$notify({
          type: 'success',
          title: this.$t('created_successfully'),
          text: 'הפעולה התבצעה בהצלחה',
          // duration: 50000
          //text: errorData?.message || this.$t('error')
        })
      }
    }, false)


  },
  components: {
    ContactModal,
    AiInsightsPanel,
    SideMenu,
    HeaderNav,
    Login,
    FindCustomerModal,
    DuplicatePhoneModal,
    TaskModal,
    PersonalItemModal,
    PlanupCalendar,
    PlanupMultiMessagesChat,
    SupportModal,
    AnnouncementPopup,
    StarterKitModal,
    HomeScreenPrompt,
    TaxDetailsPrompt,
    AccountFrozenModal,
    CommentModal,
    QuickMeetingModal,
    SummonModal,
    CancelEvent,
    ChangeEventStatus,
    DeleteCustomerModal,
    SendLinkViaWhatsappModal,
    CookieNotice,
    PageBackdrop
  },
}

</script>

<style>
.globalPdfIframeModalToolbar {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.globalPdfIframeModalNotice {
  color: #777;
  font-size: 13px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

.slide-fade-enter-active {
  transition: all .2s ease;
}

.slide-fade-leave-active {
  transition: all .1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */
  {
  transform: translateX(10px);
  opacity: 0;
}

.kioskView {
  overflow-x: hidden !important;
  overflow-y: hidden !important;
  position: fixed !important;
  width: 100% !important;
}
</style>







<style>
/* bring back this value if you want */
/* .notFullWidth {
  max-width: 1100px;
  margin: 0 auto;
} */



/* the global chat (.globalChatBoxModal) is styled in PlanupMultiMessagesChat.vue */
</style>

<style>
/* רקע המערכת: PageBackdrop paints the gray (and its drawing) behind the page, so the page's own gray steps aside */
.page-wrapper .page-body-wrapper.hasPageBackdrop .page-body {
  background-color: transparent;
}

/* עמדת אירוח: the reception-desk login runs the station edge to edge (no sidebar, no header) */
.hostingStationView.page-body-wrapper {
  margin: 0 !important;
  padding: 0 !important;
  width: 100% !important;
}
.hostingStationView .page-body {
  margin: 0 !important;
  padding: 0 !important;
  min-height: 100vh;
}
.hostingStationView .page-body > .togglePaddingBottom50 {
  padding-bottom: 0 !important;
}
</style>
